<template>
    <div>

      <v-card class="mx-auto " height="300" width="200"
      tile>
      <v-img :src="getImage('/'+avatar)"></v-img>
      <v-list-item-content><input type="file" @change="onFileSelected" ref="avatar">
      
      <v-btn  large color="blue" @click="onUpload">Upload</v-btn></v-list-item-content>
      
      </v-card> 
            
  <br>      
<br>
      <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-text-field
              label="Name"
              v-model="name"
              required
              append-icon="mdi-user">
              </v-text-field>
              <v-textarea
                label="Address"
                v-model="address"
                required
                auto-grow    
                rows="3"
            ></v-textarea>
            <v-text-field
              label="Phone"
              v-model="phone"
              required
              append-icon="mdi-phone"
            ></v-text-field>
            <v-text-field disabled
              label="Email"
              v-model="email"
              required
              append-icon="mdi-email"
            ></v-text-field>


            <v-select style="display:none;"
                v-model="province_id"
                :items="provinces"
                item-text="province"
                item-value="province_id"
                label="Province"
                persistent-hint
                single-line
            ></v-select> 

            <v-select style="display:none;"
                v-model="city_id"
                :items="citiesByProvince"
                item-text="city_name"
                item-value="city_id"
                label="City"
                persistent-hint
                single-line
            ></v-select> 

            <v-select style="display:none;"
                v-model="subdistrict_id"
                :items="subdistrictByCities"
                item-text="subdistrict_name"
                item-value="subdistrict_id"
                label="Kecamatan"
                persistent-hint
                single-line
            ></v-select> 

        



        </v-form> 


      <v-card-actions>
            <v-btn color="success" dark @click="saveProfile">
                <v-icon>mdi-content-save</v-icon> &nbsp;
                Save
            </v-btn>
       </v-card-actions>

    </div>



</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    computed: {
      ...mapGetters({
        user:'auth/user',
        provinces   : 'region/provinces',
        cities      : 'region/cities',
        subdistrict : 'region/subdistrict',
      }),
      citiesByProvince(){
        let province_id = this.province_id
        return this.cities.filter((city) => {           
            if (city.province_id==province_id) return city
        })
      },
      subdistrictByCities(){
        let city_id = this.city_id
        this.selectSubdistrict()
        return this.subdistrict.filter((subdistrict) => {           
            if (subdistrict.city_id==city_id) return subdistrict
        })
      },

    },
    data: () => ({
      valid: true,
      name: '',
      address: '',
      phone: '',
      avatar:'',
      email:'',
      referal_code:'',
      province_id:'',
      city_id:'',
      subdistrict_id:'',
      selectedFile: null,
      rand: 1,
    }),

    methods: {
       ...mapActions({
        setAlert      : 'alert/set',
        setAuth       : 'auth/set',
        setProvinces  : 'region/setProvinces',
        setCities     : 'region/setCities',
        setSubdistrict: 'region/setSubdistrict'
       }),
      selectSubdistrict(){
        if(this.city_id != 0){
            let city_id =this.city_id
            this.axios.get('/subdistrict?cities_id='+parseInt(city_id))
                    .then((response) => {
                        let { data } = response.data
                        this.setSubdistrict(data)
                    })
        }
      },
      saveProfile () {
        let formData = new FormData()
        formData.set('name', this.name)
        formData.set('address', this.address)
        formData.set('phone', this.phone)
        formData.set('province_id', this.province_id)
        formData.set('city_id', this.city_id)
        formData.set('subdistrict_id', this.subdistrict_id)
   
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        this.axios.post('/profile', formData, config)
          .then((response) => {
              let { data } = response
              this.setAuth(data.data) 
              this.setAlert({
                  status : true,
                  text  : data.message,
                  color  : 'success',
              })
          }).bind(this)
          .catch((error) => {
              let { data } = error
              this.setAlert({
                  status : true,
                  text  :  data.message,
                  color  : 'error',
              })
          })
      },
      onFileSelected(event){
        this.selectedFile = event.target.files[0]
      },
      onUpload(){

        const uploadImage = new FormData()
        uploadImage.append('image', this.selectedFile, this.selectedFile.name)
        
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        this.axios.post('/upload_image ', uploadImage, config)
        .then(response => {
          let { data } = response
              this.setAuth(data.data) 
              this.setAlert({
                  status : true,
                  text  : data.message,
                  color  : 'success',
              })
              this.selectedFile=null
              this.avatar = this.user.avatar
              
        })
        .catch((error) => {
          let {data} = error.response
          this.setAlert({
              status : true,
              text  : data.message,
              color  : 'error',
          })
        })
      },
       resetNow() {
          location.reload();
       }
    },

    created(){
        this.name = this.user.name
        this.address = this.user.address
        this.phone = this.user.phone
        this.avatar = this.user.avatar
        this.email = this.user.email
        this.referal_code = this.user.referal_code
        this.province_id= this.user.province_id
        this.city_id= this.user.city_id
        this.subdistrict_id=this.user.subdistrict_id
    },
}
</script>